type KeyString = {
  [key: string]: string
}

export const CUSTOM_FORM_ENTITY_NAME: KeyString = {
  CPF: 'CPF',
  CTPS: 'CTPS',
  PIS: 'PIS',
  STATE: 'Estado',
  COST_CENTER: 'Centro de custo',
  CITY: 'Cidade',
  CIVIL_STATE: 'Estado civil',
  LEVEL_OF_EDUCATION: 'Grau de instrução',
  DEGREES_OF_KINSHIP: 'Grau de parentesco',
  ROLE: 'Papel',
  UNIFIED_PERSON: 'Pessoa unificada',
  JOBSITE: 'Posto de trabalho',
  RACE: 'Raça',
  SALARY: 'Salário',
  PROFESSIONAL_CONTRACT_TYPE: 'Tipo de admissão',
  ORGANIZATIONAL_UNIT: 'Unidade',
}
